import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from "../components/Footer";

const DefaultLayout = ({ children }) => {
  return (
    <div>
      <header className="sticky top-0 bg-white z-50 shadow-xl">
        <Navbar />
      </header>
      { children }
      <Outlet />
      <Footer />
    </div>
  )
}

export default DefaultLayout